import { useQueryRefresh } from '../';
import { myCustomPortal } from '../queries';

export function useMyCustomPortal () {
  const { data, refresh, isLoading } = useQueryRefresh(myCustomPortal);
  return {
    data: data?.myCustomPortal?.edges?.[0]?.node,
    refresh,
    isLoading
  };
}
